import React from 'react';
import ClassAssembly  from 'views/ClassAssembly11C2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;